import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenStorageService } from '@/core/services/internal/token-storage.service';

export const adminGuard: CanActivateFn = () => {

    const router = inject(Router);
    const tokenStorage = inject(TokenStorageService);

    const user = tokenStorage.getUser();

    const isAdmin =
        user?.first_name === 'Hafid' &&
        user?.email === 'abdelhafid.dahhani@gmail.com';

    if (!isAdmin) {

        router.navigate(
            ['/auth/login'],
            {
                replaceUrl: true
            }
        );

        return false;
    }

    return true;
};